// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Data = /** @class */ (function () {
    /**
     * Constructs a new instance of telemetry data.
     */
    function Data(baseType, data) {
        /**
         * The data contract for serializing this object.
         */
        this.aiDataContract = {
            baseType: 1 /* Required */,
            baseData: 1 /* Required */
        };
        this.baseType = baseType;
        this.baseData = data;
    }
    return Data;
}());
export { Data };
//# sourceMappingURL=Data.js.map